require('./cms-policy-templates.route');
require('./cms-list-policy-templates.controller');
require('./cms-new-policy-template.controller');
require('./cms-edit-policy-template.controller');
